import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';
import { prefixRelativeUrl } from '../util.js';

$(() => {
    var slidersOnPage = null;
    var sliderContainers = $(
        '.accordion-body .RowBlock, .StartTeaserBlockContainer .RowBlock, [data-slider-root], .inquiry--admin-teasers-js .RowBlock'
    );

    function initSlider() {
        if (window.innerWidth < 768 && slidersOnPage === null) {
            slidersOnPage = [];

            var spriteMapUrl = window.spriteMapCacheBustUrl
                ? window.spriteMapCacheBustUrl
                : '/dist/spritemap.svg';

            sliderContainers.each(function (index) {
                slidersOnPage.push(
                    tns({
                        container: '[data-slider-index="' + index + '"]',
                        items: 1,
                        slideBy: 'page',
                        center: true,
                        nav: false,
                        controlsText: [
                            `<span class="sr-only">Föregående</span> <svg viewBox="0 0 24 24" class="caret">
                            <use href="${prefixRelativeUrl(
                                `${spriteMapUrl}#sprite-caret-left`
                            )}"></use>
                        </svg>`,
                            `<span class="sr-only">Nästa</span> <svg viewBox="0 0 24 24" class="caret">
                            <use href="${prefixRelativeUrl(
                                `${spriteMapUrl}#sprite-caret-right`
                            )}"></use>
                        </svg>`
                        ],
                        controls: true,
                        loop: false
                    })
                );
            });
        } else if (window.innerWidth >= 768 && slidersOnPage !== null) {
            slidersOnPage.forEach((slider) => {
                slider.destroy();
            });

            slidersOnPage = null;
        }
    }

    if (sliderContainers.length > 0) {
        sliderContainers.each(function (index) {
            $(this).attr('data-slider-index', index);
        });

        $(window).on('resize', initSlider);
        initSlider();
    }
});
